/// <reference path="../types.d.ts" />
import { Analytics } from '../actions/action-types';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { HttpMethods, appServiceLines } from '@codametrix/ui-common';
/** factories for actions */ const instantiateDashboard = createAction(Analytics.INSTANTIATE_DASHBOARD);
const setActiveDashboard = createAction(Analytics.SET_ACTIVE_DASHBOARD);
const setActiveDashboardResource = createAction(Analytics.SET_ACTIVE_DASHBOARD_RESOURCE);
const fetchTableauToken = createAsyncThunk(Analytics.GET_TABLEAU_TOKEN, async (serviceLine, { dispatch, getState, rejectWithValue })=>{
    const searchParams = new URLSearchParams({});
    if (serviceLine) {
        searchParams.set('serviceLine', serviceLine.name);
    }
    const result = await api({
        endpoint: `/tableau/token/v1?${searchParams.toString()}`,
        init: {
            method: HttpMethods.POST
        }
    });
    return result?.tableauToken ?? '';
});
const getSubNavPaths = createAsyncThunk(Analytics.GET_SUB_NAV_PATHS, async (userDetails, { dispatch, getState, rejectWithValue })=>{
    const searchParams = new URLSearchParams({});
    if (userDetails?.tenantId) {
        searchParams.set('tenantId', userDetails.tenantId);
    }
    let serviceLine = '*';
    if (userDetails?.serviceLine) {
        serviceLine = appServiceLines.isIPC(userDetails.serviceLine) ? 'Inpatient Professional Coding' : userDetails.serviceLine;
    }
    searchParams.set('serviceLine', serviceLine);
    const result = await api({
        endpoint: `/configuration/section/subnav/v2?${searchParams.toString()}`,
        init: {
            method: HttpMethods.GET
        }
    });
    return result;
});
export { instantiateDashboard, fetchTableauToken, setActiveDashboard, setActiveDashboardResource, getSubNavPaths };
